import createConverter from './lib/create_converter';
import SnippetRevision from 'models/snippet_revision';

export default createConverter(SnippetRevision);
